import kebabCase from "lodash/kebabCase";

export const convertTitleToChapterParam = (title: string) => {
  return kebabCase(title);
};

// Legacy function name for backward compatibility during migration
export const convertTitleToHash = convertTitleToChapterParam;
